import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { ProductsImportNotificatorBase } from '@skylab-shared/business';
import { EventNotificationsService } from '../event-notifications.service';

@Injectable({ providedIn: 'root'})
@Wrapper(ProductsImportNotificatorBase)
export class ProductsImportNotificator {
    public constructor(
        eventNortifications: EventNotificationsService,
        http: Http
    ) { }
}
